import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useIndeedFlexJobShiftsContextValue } from '../context/IndeedFlexJobShiftsProvider'

export const IndeedFlexJobShiftsHeader = () => {
  const { state, actions } = useIndeedFlexJobShiftsContextValue()

  return (
    <Header
      title="Indeed Flex Job Shifts"
      rightContent={
        state.hasSearchParams ? (
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        ) : null
      }
    />
  )
}
